export default __webpack_public_path__ + "static/media/11.6ac397f5.png";